import { Tooltip } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';
import { accessType as types } from '../../../../../constants/tourAccessibilityTypes.constants';
import { BikerBedIcon, BikerClubIcon } from '../../../MainMenu/svg';
import { ProfileFriendToursIcon } from '../../../UserProfile/icons.svg';
import { PrivateTourIcon, PublicTourIcon } from '../../components/svg';

const SharingOverview = ({
  accessType = false,
  friends = [],
  bikeClubs = [],
  bikerBeds = [],
}) => {
  const intl = useIntl();
  const privateTourText = intl.formatMessage({
    id: 'Private tour',
    defaultMessage: 'Private tour',
  });
  const publicTourText = intl.formatMessage({
    id: 'Public tour',
    defaultMessage: 'Public tour',
  });
  const allFriendsTourText = intl.formatMessage({
    id: 'All my friends',
    defaultMessage: 'All my friends',
  });
  const selectedFriendsTourText = intl.formatMessage({
    id: 'friends',
    defaultMessage: 'friends',
  });
  const noFriendsTourText = intl.formatMessage({
    id: 'No friends',
    defaultMessage: 'No friends',
  });
  const noBikeClubTourText = intl.formatMessage({
    id: 'No Bike Clubs',
    defaultMessage: 'No Bike Clubs',
  });
  const noBikerBedTourText = intl.formatMessage({
    id: 'No BikerBed',
    defaultMessage: 'No BikerBed',
  });
  const selectedBikeClubsTourText = intl.formatMessage({
    id: 'Bike Clubs',
    defaultMessage: 'Bike Clubs',
  });
  const selectedBikerBedsTourText = intl.formatMessage({
    id: 'BikerBeds',
    defaultMessage: 'BikerBeds',
  });
  const allTourstartUsers = intl.formatMessage({
    id: 'All Tourstart users',
    defaultMessage: 'All Tourstart users',
  });

  const SharingOverview = intl.formatMessage({
    id: 'Sharing overview',
    defaultMessage: 'Sharing overview',
  });

  const getIcon = () =>
    accessType === types.DEFAULT_ONLY_FOR_ME_TYPE ||
    accessType === types.MY_FRIENDS_AND_ME_TYPE ||
    accessType === types.SELECT_FRIENDS_TYPE ? (
      <PrivateTourIcon />
    ) : (
      <PublicTourIcon />
    );

  const getText = () =>
    accessType === types.DEFAULT_ONLY_FOR_ME_TYPE ||
    accessType === types.MY_FRIENDS_AND_ME_TYPE ||
    accessType === types.SELECT_FRIENDS_TYPE
      ? privateTourText
      : publicTourText;

  const getPtofile = () => {
    if (accessType === types.DEFAULT_ONLY_FOR_ME_TYPE) return noFriendsTourText;
    if (accessType === types.SELECT_FRIENDS_TYPE)
      return (
        <>
          <Tooltip title={friends.join(', ')}>
            <b className="friends-counter">{`${friends.length} `}</b>
            {selectedFriendsTourText}
          </Tooltip>
        </>
      );
    if (accessType === types.MY_FRIENDS_AND_ME_TYPE) return allFriendsTourText;

    return allTourstartUsers;
  };

  return (
    <section className="sharing-overview-wrapper">
      <div className="sharing-overview">
        <h3>{SharingOverview}</h3>
        <p>
          {getIcon()}
          <span>{getText()}</span>
        </p>
        <p>
          <ProfileFriendToursIcon />
          <span>{getPtofile()}</span>
        </p>
        <p>
          <BikerClubIcon />
          <span>
            {bikeClubs.length ? (
              <>
                <Tooltip title={bikeClubs.join(', ')}>
                  <b className="friends-counter">{`${bikeClubs.length} `}</b>
                  {selectedBikeClubsTourText}
                </Tooltip>
              </>
            ) : (
              noBikeClubTourText
            )}
          </span>
        </p>
        <p>
          <BikerBedIcon />
          <span>
            {bikerBeds.length ? (
              <>
                <Tooltip title={bikerBeds.join(', ')}>
                  <b className="friends-counter">{`${bikerBeds.length} `}</b>
                  {selectedBikerBedsTourText}
                </Tooltip>
              </>
            ) : (
              noBikerBedTourText
            )}
          </span>
        </p>
      </div>
    </section>
  );
};

export default SharingOverview;
